module.exports = __webpack_public_path__ + "static/media/sponsor_group5.5372e859.png";